import { registerCondition } from 'core/forms';

const isCustomAdhocLetter = ({ model }) => {
  const { radioOptions: value } = model;
  if (value === 'custom') {
    return {
      hasCondition: true,
      condition: null,
      shouldHideField: true,
    };
  }

  return {
    hasCondition: false,
    shouldHideField: false,
  };
};

registerCondition('isCustomAdhocLetter', isCustomAdhocLetter);
